export default __webpack_public_path__ + "static/media/i2.1ad29303.png";